(function () {
  'use strict';

  var scriptEl = document.currentScript;
  var SELECTOR = '.item_product_tec1';
  var JSON_FILENAME = 'tech_text_mapping.json';
  var MOBILE_QUERY = '(max-width: 767px)';

  function getJsonUrl() {
    if (scriptEl && scriptEl.dataset && scriptEl.dataset.techJsonUrl) {
      return scriptEl.dataset.techJsonUrl;
    }

    if (scriptEl && scriptEl.src) {
      try {
        var url = new URL(scriptEl.src, window.location.href);
        url.pathname = url.pathname.replace(/\/[^/]*$/, '/' + JSON_FILENAME);
        url.search = '';
        url.hash = '';
        return url.href;
      } catch (e) {}
    }

    return JSON_FILENAME;
  }

  function escapeRegExp(value) {
    return value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  }

  function buildFlexiblePattern(key) {
    var chars = Array.from(String(key).normalize('NFKC'));
    var pattern = '';
    var inSeparator = false;

    chars.forEach(function (char) {
      var isSeparator = /[\s\-‐‑‒–—−]/.test(char);

      if (isSeparator) {
        if (!inSeparator) {
          pattern += '[\\s\\-‐‑‒–—−]+';
          inSeparator = true;
        }
        return;
      }

      inSeparator = false;
      pattern += escapeRegExp(char);
    });

    return pattern;
  }

  function isAsciiAlphaNumeric(char) {
    return !!char && /[A-Za-z0-9]/.test(char);
  }

  function createEntries(mapping) {
    return Object.keys(mapping)
      .filter(function (key) {
        return key && typeof mapping[key] === 'string' && mapping[key].trim() !== '';
      })
      .map(function (key) {
        return {
          key: key,
          description: mapping[key].trim(),
          regex: new RegExp(buildFlexiblePattern(key), 'gi')
        };
      });
  }

  function findMatches(text, entries) {
    var matches = [];

    entries.forEach(function (entry) {
      entry.regex.lastIndex = 0;
      var match;

      while ((match = entry.regex.exec(text)) !== null) {
        var start = match.index;
        var end = start + match[0].length;
        var before = start > 0 ? text.charAt(start - 1) : '';
        var after = end < text.length ? text.charAt(end) : '';

        if (!isAsciiAlphaNumeric(before) && !isAsciiAlphaNumeric(after)) {
          matches.push({
            start: start,
            end: end,
            key: entry.key,
            description: entry.description,
            label: match[0]
          });
        }

        if (match[0].length === 0) {
          entry.regex.lastIndex += 1;
        }
      }
    });

    matches.sort(function (a, b) {
      var lengthDiff = (b.end - b.start) - (a.end - a.start);
      return lengthDiff || a.start - b.start;
    });

    var selected = [];

    matches.forEach(function (candidate) {
      var overlaps = selected.some(function (current) {
        return candidate.start < current.end && candidate.end > current.start;
      });

      if (!overlaps) {
        selected.push(candidate);
      }
    });

    selected.sort(function (a, b) {
      return a.start - b.start;
    });

    return selected;
  }

  function createTrigger(match) {
    var button = document.createElement('button');
    button.type = 'button';
    button.className = 'ale-tech-term';
    button.textContent = match.label;
    button.setAttribute('aria-haspopup', 'dialog');
    button.setAttribute('aria-expanded', 'false');
    button.dataset.techTitle = match.label.trim();
    button.dataset.techKey = match.key;
    button.dataset.techDescription = match.description;
    return button;
  }

  function enhanceTextNode(textNode, entries) {
    var text = textNode.nodeValue;
    if (!text || !text.trim()) return false;

    var matches = findMatches(text, entries);
    if (!matches.length) return false;

    var fragment = document.createDocumentFragment();
    var cursor = 0;

    matches.forEach(function (match) {
      if (match.start > cursor) {
        fragment.appendChild(document.createTextNode(text.slice(cursor, match.start)));
      }

      fragment.appendChild(createTrigger(match));
      cursor = match.end;
    });

    if (cursor < text.length) {
      fragment.appendChild(document.createTextNode(text.slice(cursor)));
    }

    textNode.parentNode.replaceChild(fragment, textNode);
    return true;
  }

  function enhanceElement(element, entries) {
    if (!element || element.dataset.techEnhanced === 'true') return;
    element.dataset.techEnhanced = 'true';

    var walker = document.createTreeWalker(
      element,
      NodeFilter.SHOW_TEXT,
      {
        acceptNode: function (node) {
          if (!node.nodeValue || !node.nodeValue.trim()) {
            return NodeFilter.FILTER_REJECT;
          }

          if (node.parentElement && node.parentElement.closest('.ale-tech-term')) {
            return NodeFilter.FILTER_REJECT;
          }

          return NodeFilter.FILTER_ACCEPT;
        }
      }
    );

    var textNodes = [];
    var current;

    while ((current = walker.nextNode())) {
      textNodes.push(current);
    }

    textNodes.forEach(function (node) {
      enhanceTextNode(node, entries);
    });
  }

  function injectStyles() {
    if (document.getElementById('ale-tech-text-style')) return;

    var style = document.createElement('style');
    style.id = 'ale-tech-text-style';
    style.textContent = [
      '.ale-tech-term{appearance:none;-webkit-appearance:none;display:inline;padding:0;margin:0;border:0;background:transparent;color:inherit;font:inherit;line-height:inherit;text-align:inherit;text-decoration-line:underline;text-decoration-style:dotted;text-decoration-thickness:1px;text-underline-offset:3px;cursor:pointer;}',
      '.ale-tech-term:hover,.ale-tech-term:focus-visible{text-decoration-style:solid;}',
      '.ale-tech-term:focus-visible{outline:2px solid currentColor;outline-offset:3px;border-radius:2px;}',
      '.ale-tech-popup{position:fixed;z-index:10001;width:min(380px,calc(100vw - 32px));box-sizing:border-box;padding:20px 44px 20px 20px;background:#fff;color:#222;border:1px solid rgba(0,0,0,.12);border-radius:10px;box-shadow:0 12px 34px rgba(0,0,0,.16);opacity:0;transform:translateY(5px);pointer-events:none;transition:opacity .18s ease,transform .18s ease;}',
      '.ale-tech-popup.is-open{opacity:1;transform:translateY(0);pointer-events:auto;}',
      '.ale-tech-popup[hidden],.ale-tech-backdrop[hidden]{display:none!important;}',
      '.ale-tech-popup__title{margin:0 0 10px;font-size:15px;font-weight:700;line-height:1.5;}',
      '.ale-tech-popup__text{margin:0;font-size:13px;line-height:1.8;white-space:pre-line;}',
      '.ale-tech-popup__close{appearance:none;-webkit-appearance:none;position:absolute;top:10px;right:10px;width:30px;height:30px;padding:0;border:0;background:transparent;color:#222;font-size:24px;font-weight:300;line-height:30px;text-align:center;cursor:pointer;}',
      '.ale-tech-popup__close:focus-visible{outline:2px solid currentColor;outline-offset:1px;border-radius:50%;}',
      '.ale-tech-backdrop{position:fixed;z-index:10000;inset:0;background:transparent;pointer-events:none;}',
      '@media screen and (max-width:767px){',
      'body.ale-tech-no-scroll{overflow:hidden;}',
      '.ale-tech-backdrop{background:rgba(0,0,0,.36);pointer-events:auto;}',
      '.ale-tech-popup{left:12px!important;right:12px!important;top:auto!important;bottom:12px;width:auto;max-height:min(70vh,520px);overflow:auto;padding:24px 46px 24px 20px;border-radius:14px;transform:translateY(14px);}',
      '.ale-tech-popup.is-open{transform:translateY(0);}',
      '.ale-tech-popup__title{font-size:16px;}',
      '.ale-tech-popup__text{font-size:14px;line-height:1.85;}',
      '}'
    ].join('');

    document.head.appendChild(style);
  }

  function createPopupController() {
    var popup = document.createElement('div');
    popup.className = 'ale-tech-popup';
    popup.hidden = true;
    popup.setAttribute('role', 'dialog');
    popup.setAttribute('aria-modal', 'false');
    popup.setAttribute('aria-labelledby', 'ale-tech-popup-title');
    popup.setAttribute('aria-describedby', 'ale-tech-popup-text');

    var title = document.createElement('p');
    title.className = 'ale-tech-popup__title';
    title.id = 'ale-tech-popup-title';

    var text = document.createElement('p');
    text.className = 'ale-tech-popup__text';
    text.id = 'ale-tech-popup-text';

    var closeButton = document.createElement('button');
    closeButton.type = 'button';
    closeButton.className = 'ale-tech-popup__close';
    closeButton.setAttribute('aria-label', '説明を閉じる');
    closeButton.textContent = '×';

    var backdrop = document.createElement('div');
    backdrop.className = 'ale-tech-backdrop';
    backdrop.hidden = true;

    popup.appendChild(title);
    popup.appendChild(text);
    popup.appendChild(closeButton);
    document.body.appendChild(backdrop);
    document.body.appendChild(popup);

    var activeTrigger = null;
    var rafId = null;
    var mobileMedia = window.matchMedia(MOBILE_QUERY);

    function isMobile() {
      return mobileMedia.matches;
    }

    function positionPopup() {
      if (!activeTrigger || popup.hidden || isMobile()) return;

      var margin = 12;
      var gap = 10;
      var triggerRect = activeTrigger.getBoundingClientRect();
      var popupRect = popup.getBoundingClientRect();
      var left = triggerRect.left;
      var top = triggerRect.bottom + gap;

      if (left + popupRect.width > window.innerWidth - margin) {
        left = window.innerWidth - popupRect.width - margin;
      }

      if (left < margin) {
        left = margin;
      }

      if (top + popupRect.height > window.innerHeight - margin) {
        var above = triggerRect.top - popupRect.height - gap;
        if (above >= margin) {
          top = above;
        } else {
          top = Math.max(margin, window.innerHeight - popupRect.height - margin);
        }
      }

      popup.style.left = Math.round(left) + 'px';
      popup.style.top = Math.round(top) + 'px';
    }

    function schedulePosition() {
      if (rafId) cancelAnimationFrame(rafId);
      rafId = requestAnimationFrame(positionPopup);
    }

    function close(options) {
      options = options || {};
      if (!activeTrigger) return;

      var triggerToRestore = activeTrigger;
      triggerToRestore.setAttribute('aria-expanded', 'false');
      activeTrigger = null;

      popup.classList.remove('is-open');
      backdrop.hidden = true;
      document.body.classList.remove('ale-tech-no-scroll');

      window.setTimeout(function () {
        if (!activeTrigger) {
          popup.hidden = true;
        }
      }, 180);

      if (options.restoreFocus) {
        triggerToRestore.focus({ preventScroll: true });
      }
    }

    function open(trigger) {
      if (activeTrigger === trigger) {
        close();
        return;
      }

      if (activeTrigger) {
        activeTrigger.setAttribute('aria-expanded', 'false');
      }

      activeTrigger = trigger;
      activeTrigger.setAttribute('aria-expanded', 'true');

      title.textContent = trigger.dataset.techTitle || trigger.dataset.techKey || '生地について';
      text.textContent = trigger.dataset.techDescription || '';
      popup.hidden = false;
      backdrop.hidden = !isMobile();
      popup.setAttribute('aria-modal', isMobile() ? 'true' : 'false');

      if (isMobile()) {
        document.body.classList.add('ale-tech-no-scroll');
        popup.style.left = '';
        popup.style.top = '';
      } else {
        document.body.classList.remove('ale-tech-no-scroll');
        schedulePosition();
      }

      requestAnimationFrame(function () {
        if (!activeTrigger) return;
        popup.classList.add('is-open');
        if (isMobile()) {
          closeButton.focus({ preventScroll: true });
        }
      });
    }

    document.addEventListener('click', function (event) {
      var trigger = event.target.closest('.ale-tech-term');

      if (trigger) {
        event.preventDefault();
        open(trigger);
        return;
      }

      if (activeTrigger && !popup.contains(event.target)) {
        close();
      }
    });

    closeButton.addEventListener('click', function () {
      close({ restoreFocus: true });
    });

    backdrop.addEventListener('click', function () {
      close({ restoreFocus: true });
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && activeTrigger) {
        close({ restoreFocus: true });
      }
    });

    window.addEventListener('resize', schedulePosition, { passive: true });
    window.addEventListener('scroll', schedulePosition, { passive: true });

    if (mobileMedia.addEventListener) {
      mobileMedia.addEventListener('change', function () {
        if (!activeTrigger) return;

        popup.setAttribute('aria-modal', isMobile() ? 'true' : 'false');
        backdrop.hidden = !isMobile();

        if (isMobile()) {
          document.body.classList.add('ale-tech-no-scroll');
          popup.style.left = '';
          popup.style.top = '';
        } else {
          document.body.classList.remove('ale-tech-no-scroll');
          schedulePosition();
        }
      });
    }

    return {
      close: close
    };
  }

  function start(mapping) {
    var entries = createEntries(mapping);
    if (!entries.length) return;

    injectStyles();
    createPopupController();

    function enhanceAll(root) {
      var scope = root || document;

      if (scope.nodeType === 1 && scope.matches && scope.matches(SELECTOR)) {
        enhanceElement(scope, entries);
      }

      if (scope.querySelectorAll) {
        scope.querySelectorAll(SELECTOR).forEach(function (element) {
          enhanceElement(element, entries);
        });
      }
    }

    enhanceAll(document);

    var observerTimer = null;
    var observer = new MutationObserver(function (mutations) {
      var shouldScan = mutations.some(function (mutation) {
        return mutation.addedNodes && mutation.addedNodes.length > 0;
      });

      if (!shouldScan) return;

      window.clearTimeout(observerTimer);
      observerTimer = window.setTimeout(function () {
        enhanceAll(document);
      }, 50);
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  function init() {
    fetch(getJsonUrl(), { cache: 'force-cache' })
      .then(function (response) {
        if (!response.ok) {
          throw new Error('HTTP ' + response.status);
        }
        return response.json();
      })
      .then(function (mapping) {
        start(mapping);
      })
      .catch(function (error) {
        console.error('[ALE Tech Text] JSONの読み込みに失敗しました:', error);
      });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
